export default "__VITE_ASSET__660f1733__"